/**
 * Represents different types of audit events in rebate load service
 */
export enum RebatesLoadAuditEventTypeModel {
	/**
	 * Upload Rebate Load File
	 */
	UploadRebateLoadFile = 1,
	/**
	 * Update Rebate Load File Mapping
	 */
	UpdateRebateLoadFileFileMapping = 2,
	/**
	 * Save Rebate Load Template
	 */
	SaveRebateLoadTemplate = 3,
	/**
	 * Delete Rebate Load Template
	 */
	DeleteRebateLoadTemplate = 4,
	/**
	 * Update Rebate Invalid Records
	 */
	UpdateRebateInvalidRecords = 10,
	/**
	 * Delete Rebate Invalid Records by Error Code
	 */
	DeleteRebateInvalidRecordsByErrorCode = 11,
	/**
	 * Bulk Update Rebate Invalid Records
	 */
	BulkUpdateRebateInvalidRecords = 12,
	/**
	 * Resolve Rebate Invalid Records via Bulk Action
	 */
	ResolveRebateInvalidRecordsViaBulkAction = 13,
	/**
	 * Change Location Mapping
	 */
	ChangeLocationMapping = 15,
	/**
	 * Exclude Location
	 */
	ExcludeLocations = 16,
	/**
	 * Review Pharmacy ID Record
	 */
	ReviewPharmacyIdRecord = 20,
	/**
	 * Resolve All Rebate Load File Duplicates
	 */
	ResolveAllRebateLoadFileDuplicates = 30,
	/**
	 * Resolve Rebate Load File Record Duplicate
	 */
	ResolveRebateLoadFileRecordDuplicate = 31,
	/**
	 * Resolve All Cross Rebate Load Files Duplicates
	 */
	ResolveAllCrossRebateLoadFilesDuplicates = 32,
	/**
	 * Resolve Cross Rebate Load File Records Duplicates
	 */
	ResolveCrossRebateLoadFileRecordsDuplicates = 33,
	/**
	 * Aggregate Rebate Load File
	 */
	AggregateRebateLoadFile = 40,
	/**
	 * Rebate Load File Converted
	 */
	RebateLoadFileConverted = 50,
	/**
	 * Reset Conversion Type
	 */
	ResetConversionType = 51,
	/**
	 * Resolve Aberrant Quantity Records
	 */
	ResolveAberrantQuantityRecords = 52,
	/**
	 * Apply Conversion Coefficient
	 */
	ApplyConversionCoefficient = 60,
	/**
	 * Mark Filtered Rebate Records as Deleted
	 */
	MarkFilteredRebateRecordsAsDeleted = 61,
	/**
	 * Set Rebate Records Quantity
	 */
	SetRebateRecordsQuantity = 62,
	/**
	 * Recovery JCodes
	 */
	RecoveryJCodes = 63,
	/**
	 * Recovery NDC-JCode Coefficients
	 */
	RecoveryNdcJCodeCoefficients = 64,
	/**
	 * Process Rebate Load File
	 */
	ProcessRebateLoadFile = 70,
	/**
	 * Delete Rebate Load File
	 */
	DeleteRebateLoadFile = 80,
	/**
	 * Rollback Rebate Load File
	 */
	RollbackRebateLoadFile = 90,
	/**
	 * Final Review Rebate Load File
	 */
	FinalReviewRebateLoadFile = 100,
	/**
	 * Rebate Load File Failed
	 */
	RebateLoadFileFailed = 110
}
